<template>
  <div>
    <loading 
      :active.sync="isLoading" 
      color="#64B9B0"
    ></loading>
    <div class="content-wrapper">
      <div class="container-fluid">
        <!-- Breadcrumbs-->
        <ol class="breadcrumb">
          <li class="breadcrumb-item active">Painel</li>
        </ol>

        <div class="flex justify-content-center">
          <div class="justify-content-center card text-center"
            style="
              width: 260px;
              height: 130px;
              background-color: #8B82EA;
          ">
                <p class="color-white font-weight-bold text_responsive">
                  Denúncias Recebidas
                </p>
                <p class="color-white font-weight-bold"
                  style="font-size: 1.5rem;
                ">
                  {{ cards.denuncias_recebidas }}
                </p>
          </div>
          <div class="justify-content-center card text-center mx-3"
            style="
              width: 260px;
              height: 130px;
              background-color: #989898;
          ">
                <p class="color-white font-weight-bold text_responsive">
                  Em análise
                </p>
                <p class="color-white font-weight-bold"
                  style="font-size: 1.5rem;
                ">
                  {{ cards.denuncias_em_analise }}
                </p>
          </div>
          <div class="justify-content-center card text-center"
            style="
              width: 260px;
              height: 130px;
              background-color: #448634;
          ">
                <p class="color-white font-weight-bold text_responsive">
                  Finalizadas
                </p>
                <p class="color-white font-weight-bold"
                  style="font-size: 1.5rem;
                ">
                  {{ cards.denuncias_finalizadas }}
                </p>
          </div>
        </div>

        <div class="flex justify-content-center mb-3">
          <div class="justify-content-center card text-center mt-3"
            style="
              width: 260px;
              height: 130px;
              background-color: #96462C;
          ">
                <p class="color-white font-weight-bold text_responsive">
                  Procedentes
                </p>
                <p class="color-white font-weight-bold"
                  style="font-size: 1.5rem;
                ">
                  {{ cards.denuncias_procedentes }}
                </p>
          </div>
          <div class="justify-content-center card text-center mt-3 ml-3"
            style="
              width: 260px;
              height: 130px;
              background-color: #3A3A3A;
          ">
                <p class="color-white font-weight-bold text_responsive">
                  Improcedentes
                </p>
                <p class="color-white font-weight-bold"
                  style="font-size: 1.5rem;
                ">
                  {{ cards.denuncias_improcedentes }}
                </p>
          </div>
          <div class="justify-content-center card text-center mt-3 ml-3"
            style="
              width: 260px;
              height: 130px;
              background-color: #d6c528;
          ">
                <p class="color-white font-weight-bold text_responsive">
                  Inconclusivas
                </p>
                <p class="color-white font-weight-bold"
                  style="font-size: 1.5rem;
                ">
                  {{ cards.denuncias_inconclusivas }}
                </p>
          </div>
        </div>

        <v-card>
          <v-card-title>
            <h3>Últimas denúncias recebidas</h3>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Filtrar"
              single-line
              hide-details
            ></v-text-field>
          </v-card-title>
          <v-data-table rows-per-page-text="Linhas por Página" :no-data-text="textoTabela" :disable-initial-sort="true" :headers="headers" :items="ultimas_denuncias" :search="search" :pagination.sync="pagination" class="less-space">
            <template slot="items" slot-scope="props" v-if="!(props.item.deleted_at)">
              <td>{{ padronizaData(props.item.created_at)}}</td>
              <td>{{ props.item.nome_unidade }}</td>
              <td>{{ props.item.nome_empresa }}</td>
              <td>{{ props.item.tipo_denuncia }}</td>
              <td>{{ props.item.status_atual }}</td>
              <td>{{ props.item.protocolo }}</td>
              <td></td>
              <td class="text-xs-right many-buttons">
                <router-link
                  class="btn mr-2 text-white blue-grey darken-4"
                  :to="'denuncias/'+props.item.id"
                >
                  <i class="fa fa-eye"></i> Detalhes
                </router-link>
              </td>
            </template>
            <v-alert
              slot="no-results"
              :value="true"
              color="error"
              icon="warning"
            >Sua consulta para "{{ search }}" não teve resultado.</v-alert>
          </v-data-table>
        </v-card>
      </div>
      <!-- /container-fluid-->
    </div>
  </div>
</template>

<script>
import funcoesGerais from "@/assets/js/funcoes.js";
import { ajax, tratamento_requisicao, alerta, confirma } from "@/utils/util";

export default {
  mixins: [funcoesGerais],
  data() {
    return {
      search: "",
      pagination: {
        rowsPerPage: 5
      },
      isLoading: false,
      headers: [
        { text: "Data", value: "created_at" },
        { text: "Unidade", value: "unidade"},
        { text: "Empresa", value: "empresa"},
        { text: "Tipo de Denúncia", value: "tipo_denuncia"},
        { text: "Status", value: "status_atual" },
        { text: "Protocolo", value: "protocolo" },
        { text: "", value: ""}
      ],
      ultimas_denuncias: [],
      cards: {
        denuncias_recebidas: 0,
        denuncias_em_analise: 0,
        denuncias_finalizadas: 0,
        denuncias_procedentes: 0,
        denuncias_improcedentes: 0,
        denuncias_inconclusivas: 0
      },
      tipos_denuncia: [
        { tipo:'Assédio Moral', id: 1},
        { tipo:'Assédio Sexual', id: 2},
        { tipo:'Descumprimento de Normas', id: 3},
        { tipo:'Fraude/Corrupção/Suborno', id: 4},
        { tipo:'Outros', id: 5}
      ],
      status: [
        { status:'Recebida', id: 1},
        { status:'Em Análise', id: 2},
        { status:'Finalizada', id: 3},
        { status:'Procedente', id: 4},
        { status:'Improcedente', id: 5},
        { status:'Inconclusiva', id: 6}
      ]
    };
  },
  mounted() {
    var self = this;
    self.isLoading = true;

    ajax("get", "home_painel")
      .then(res => {
        self.isLoading = false;
        self.ultimas_denuncias = res.ultimas_denuncias;
        self.cards.denuncias_recebidas = res.denuncias_recebidas
        self.cards.denuncias_em_analise = res.denuncias_em_analise
        self.cards.denuncias_finalizadas = res.denuncias_finalizadas
        self.cards.denuncias_procedentes = res.denuncias_procedentes
        self.cards.denuncias_improcedentes = res.denuncias_improcedentes
        self.cards.denuncias_inconclusivas = res.denuncias_inconclusivas

        self.ultimas_denuncias.forEach(item => {
          let temp = self.tipos_denuncia.find(s => s.id === item.tipo_denuncia)
          let temp2 = self.status.find(s => s.id === item.status_atual)
          item.tipo_denuncia = temp.tipo
          item.status_atual = temp2.status
        })
      })
      .catch(error => {
        self.isLoading = false;
        tratamento_requisicao(error);
      });
  },
  methods: {
    async desativauser(user){
      if(await confirma()) {
        let self = this;
        self.isLoading = true;
        ajax("delete", "users/" + user.id)
          .then(() => {
            let indexItemRemovido = self.usuarios.findIndex(
              x => x.id == user.id
            );
            self.usuarios[indexItemRemovido].deleted_at = 1;
            self.isLoading = false;
            alerta(
              "success",
              "Desativado",
              "Usuário desativado com sucesso!"
            );
          })
          .catch(error => {
            self.isLoading = false;
            tratamento_requisicao(error);
          });
      }
    }
  }
};
</script>

<style scoped>
.text_responsive {
  font-size: 1.5rem;
}

@media (min-width: 415px) and (max-width: 500px) {
  .text_responsive {
    font-size: 1.2rem;
  }
}

@media (min-width: 350px) and (max-width: 414px) {
  .text_responsive {
    font-size: 1rem;
  }
}

@media (max-width: 350px) {
  .text_responsive {
    font-size: 0.9rem;
  }
}
</style>